import React, { useState } from 'react';
import { Link } from 'gatsby';
import { RiShoppingCartFill as CartIcon } from 'react-icons/ri';
import { FaBars, FaTimes } from 'react-icons/fa';
import Logo from '../assets/svg/ijblogo.svg';
import styled from 'styled-components';

const NavStyles = styled.nav`
    max-width: var(--container);
    margin: 0 auto;
    display: flex;
    padding: 0 1.5rem;
`;

const LogoStyles = styled.div`
    color: var(--white);

    svg {
        height: 7rem;
        width: 7rem;
        fill: var(--white);
        display: block;
    }
`;

const ListStyles = styled.ul`
    list-style: none;
    display: flex;
    align-items: center;
    margin-left: auto;
    @media (max-width: 650px) {
        position: absolute;
        flex-direction: column;
        right: 0;
        background: var(--black);
        height: 100vh;
        width: 50%;
        padding: 7rem;
        z-index: 99;
        display: ${props => props.open ? `flex` : 'none'};
    }

    .open {
        display: flex;
    }

    li {
        padding: 0 2rem;
        @media (max-width: 650px) {
            padding: .5rem 2rem;
        }
        a {
            color: var(--white);
            display: inline-block;
            &:hover {
                color: var(--red);
            }
        }
    }
`;

const CartStyles = styled.div`
    display: flex;
    align-items: center;
    padding: 0 1rem;

    button {
            display: flex;

            svg {
                margin-right: .5rem;
            }
        }

        .snipcart-items-count {
            font-family: HammersmithOne;
    }

    @media (max-width: 650px) {
        position: absolute;
        right: 50%0;
        right: 50%;
        transform: translate(60%, 75%);
        padding: 0;
    }
`;

const NavToggleStyles = styled.button`
    background-color: var(--black);
    color: var(--white);
    font-size: 4rem;
    line-height: .8;
    padding-bottom: 0;
    position: absolute;
    right: 1.5rem;
    top: 1rem;
    z-index: 999;
    cursor: pointer;
    display: none;
    @media (max-width: 650px) {
        display: block;
    }
`;

export default function Nav() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <NavStyles>
            <LogoStyles>
                <Link to={'/'} aria-label="site logo">
                    <Logo />
                </Link>
            </LogoStyles>
            <NavToggleStyles onClick={() => setIsOpen(!isOpen)} aria-controls="mobile-navigation">
                {
                    isOpen ? <FaTimes /> : <FaBars />
                }
            </NavToggleStyles>
            <ListStyles open={isOpen} id="mobile-navigation">
                <li>
                    <Link to={'/'} onClick={() => { if(isOpen) { setIsOpen(false) } }}>Home</Link>
                </li>
                <li>
                    <Link to={'/about'} onClick={() => { if(isOpen) { setIsOpen(false) } }}>About</Link>
                </li>
                <li>
                    <Link to={'/products'} onClick={() => { if(isOpen) { setIsOpen(false) } }}>Products</Link>
                </li>
            </ListStyles>
            <CartStyles>
                <button className="snipcart-checkout">
                    <CartIcon /> Cart(<span className="snipcart-items-count cart-item-count"></span>)
                </button>
            </CartStyles>
        </NavStyles>
    )
}